/* eslint simple-import-sort/imports: 0 */
import "@/i18n";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import { startOtelInstrumentation } from "@/otel-exporter";
import { scan } from "react-scan"; // We need this to be imported before React

import { Toaster, TooltipProvider } from "@hellocarbo/lasagne";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";
import root from "react-shadow";

import styles from "@/index.css?inline";
import router from "@/router";

import { getEnv } from "./utils/environment";
import { analytics, SEGMENT_WRITE_KEY_BY_ENVIRONMENT } from "./utils/segment";

import { Provider } from "@rollbar/react";

// Add this before the initialization of your main App, so it can capture all the traces.
if (`${import.meta.env.VITE_TELEMETRY_ENABLED}` === "true") {
  startOtelInstrumentation();
}

// See https://github.com/tailwindlabs/tailwindcss/issues/15005#issuecomment-2737489813
// Move custom CSS properties (@property) to :host instead of :root (being the shadow-dom root)
const shadowSheet = new CSSStyleSheet();
shadowSheet.replaceSync(styles.replace(/:root/gu, ":host"));

const globalSheet = new CSSStyleSheet();
for (const rule of shadowSheet.cssRules) {
  if (rule instanceof CSSPropertyRule) {
    globalSheet.insertRule(rule.cssText);
  }
}
document.adoptedStyleSheets.push(globalSheet);

const environment = getEnv(window.location.href);

const segmentWriteKey = SEGMENT_WRITE_KEY_BY_ENVIRONMENT[environment!];

const rollbarConfig = {
  enabled: true, // because of build_frontend.sh script
  accessToken: `${import.meta.env.VITE_ROLLBAR_CLIENT_ACCESS_TOKEN}`,
  environment,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        code_version: "1.0.0",
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
};

analytics.load({
  writeKey: segmentWriteKey ? `${import.meta.env[segmentWriteKey]}` : "",
});

// Keep React Router in sync with Turbo
document.addEventListener("turbo:load", function () {
  router.navigate(window.location.pathname + window.location.search, {
    replace: true,
    state: { ...window.history.state },
  });
});

window.addEventListener("popstate", () => {
  const Turbo = window.Turbo;
  Turbo.visit(window.location.href, { action: "replace" });
});

scan({
  enabled: false,
  showToolbar: import.meta.env.MODE === "development",
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <root.div>
      <div id="app">
        <Provider config={rollbarConfig}>
          <TooltipProvider>
            <RouterProvider router={router} />
            <style type="text/css">{styles}</style>
            <Toaster />
          </TooltipProvider>
        </Provider>
      </div>
    </root.div>
  </React.StrictMode>
);
